import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import './hospital.css';
import '../assets/css/mainstyle.css';
import group from '../assets/images/Group 174.png';
import modal from '../assets/images/modal.png';
import { Modal, Button } from 'react-bootstrap';
import { FaArrowUp, FaArrowRight, FaRegTrashAlt, FaListAlt, FaArrowDown, FaPodcast, FaEdit } from "react-icons/fa";
import {
  CHeader, CContainer, CHeaderNav, CNavItem, CNavLink,
} from '@coreui/react'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { BsPersonPlus, BsChevronRight, BsChevronLeft, BsArrowUpLeft } from 'react-icons/bs';
import api from '../service/caller'
import { CountrySelect, StateSelect, CitySelect } from "react-country-state-city";
import "react-country-state-city/dist/react-country-state-city.css";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import Adminprofil from '../assets/images/adminprofil.png';
import Speciality from './clientviews/speciality';

import { getUserIdFromToken } from '../utils/authUtils';


const Hospital = () => {

  const [UserData, setUserData] = useState([]);
  const [showEditDepartmentModal, setShowEditDepartmentModal] = useState(false);
  const [editingDepartment, setEditingDepartment] = useState(null);

  const handleShowEditDepartmentModal = (dept) => {
    setEditingDepartment(dept);
    setShowEditDepartmentModal(true);
  };

  const handleCloseEditDepartmentModal = () => {
    setShowEditDepartmentModal(false);
    setEditingDepartment(null);
  };

  const handleEditDepartmentInputChange = (e) => {
    const { name, value } = e.target;
    setEditingDepartment({ ...editingDepartment, [name]: value });
  };

  const updateDepartment = async () => {
    if (!editingDepartment || !editingDepartment._id) {
      toast.error('No department selected for update');
      return;
    }

    try {
      const token = localStorage.getItem('access_token');

      const response = await api.put(`/api/updatedepartment`, {
        department_id: editingDepartment._id,
        name: editingDepartment.name,
        price_consult: editingDepartment.price_consult,
        description: editingDepartment.description,
      }, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      // Update the departments list with the edited department
      const updatedDepartments = departments.map(dept =>
        dept._id === editingDepartment._id ? response.data : dept
      );

      setDepartments(updatedDepartments);
      toast.success('Department updated successfully!');
      handleCloseEditDepartmentModal();

    } catch (error) {
      console.error('Error updating department:', error);
      toast.error('Failed to update department');
    }
  };

  useEffect(() => {
    const fetchLoggedUserData = async () => {
      try {
        const response = await api.get('api/usersprofile');

        setUserData(response.data);
      } catch (error) {
        toast.error("Failed to fetch data");
      }
    };
    fetchLoggedUserData();
  }, []);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [mainHospital, setMainHospital] = useState(null);  // Stocker l'hôpital principal
  const [otherHospitals, setOtherHospitals] = useState([]);  // Stocker les autres hôpitaux
  const [hospitals, setHospitals] = useState([]);
  const [selectedHospitalId, setSelectedHospitalId] = useState(UserData.main_hospital_id);
  const [filteredSpecialities, setFilteredSpecialities] = useState([]);
  const [errors, setErrors] = useState({});

  // New state for edit modals
  const [showEditSpecialityModal, setShowEditSpecialityModal] = useState(false);
  const [showEditServiceModal, setShowEditServiceModal] = useState(false);
  const [editingSpeciality, setEditingSpeciality] = useState(null);
  const [editingService, setEditingService] = useState(null);

  const handleHospitalChange = (hospitalId) => {
    setSelectedHospitalId(hospitalId);
    // Mettre à jour les autres états liés à l'hôpital sélectionné si nécessaire
  };


  const [dropdownState, setDropdownState] = useState({
    main: true,
    generalSettings: false,
    specialities: true,
    departments: true,
    services: true,
  });

  const toggleDropdown = (key) => {
    setDropdownState((prevState) => ({
      ...prevState,
      [key]: !prevState[key], // Basculer l'état spécifique du dropdown
    }));
  };
  const [showModal, setShowModal] = useState(false);
  const [showSpecialityModal, setShowSpecialityModal] = useState(false);
  const [showServiceModal, setShowServiceModal] = useState(false);
  const [hasOtherSites, setHasOtherSites] = useState(false); // État pour "Do you have other sites?"
  const [createSubAdmin, setCreateSubAdmin] = useState(false); // État pour "Create subadmin?"
  const [departments, setDepartments] = useState([]);
  const [specialities, setSpecialities] = useState([]);
  const [services, setServices] = useState([]);

  const [newDepartment, setNewDepartment] = useState({
    name: '',
    price_consult: '',
    description: '',
  });

  const [newSpeciality, setNewSpeciality] = useState({
    name: '',
    description: '',
    departementId: [],
  });

  const [newService, setNewService] = useState({
    name: '',
    departementId: '',
    specialityId: '',
    description: '',
    price_service: '',
  });

  // Fonction pour ouvrir et fermer le dropdown Main Hospital
  const toggleMainDropdown = () => toggleDropdown("main");

  // Fonction pour ouvrir et fermer le dropdown Departments
  const toggleDepartments = () => toggleDropdown("departments");

  // Fonction pour ouvrir et fermer le dropdown Specialities
  const toggleSpecialities = () => toggleDropdown("specialities");

  // Fonction pour ouvrir et fermer le dropdown Services
  const toggleServices = () => toggleDropdown("services");

  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  const userId = getUserIdFromToken(); // Récupérer l'ID de l'utilisateur à partir du token
  const handleShowSpecialityModal = () => setShowSpecialityModal(true);
  const handleCloseSpecialityModal = () => setShowSpecialityModal(false);

  const handleShowServiceModal = () => setShowServiceModal(true);
  const handleCloseServiceModal = () => setShowServiceModal(false);

  // Handlers for edit modals
  const handleShowEditSpecialityModal = (speciality) => {
    setEditingSpeciality({
      ...speciality,
      // Ensure departementId is an array for multiselect
      departementId: Array.isArray(speciality.departementId) ? speciality.departementId : [speciality.departementId]
    });
    setShowEditSpecialityModal(true);
  };

  const handleCloseEditSpecialityModal = () => {
    setShowEditSpecialityModal(false);
    setEditingSpeciality(null);
  };

  const handleShowEditServiceModal = (service) => {
    setEditingService(service);

    // When editing a service, we need to load the appropriate specialities for the department
    if (service.departementId) {
      const updatedSpecialities = specialities.filter(
        (speciality) => speciality.departementId && speciality.departementId.includes(service.departementId)
      );
      setFilteredSpecialities(updatedSpecialities);
    }

    setShowEditServiceModal(true);
  };

  const handleCloseEditServiceModal = () => {
    setShowEditServiceModal(false);
    setEditingService(null);
  };

  const handleSpecialityInputChange = (e) => {
    const { name, value } = e.target;

    // Special handling for multi-select
    if (name === "departementId") {
      // Convert selected options to an array of values
      const selectedOptions = Array.from(e.target.selectedOptions).map(option => option.value);
      setNewSpeciality({ ...newSpeciality, [name]: selectedOptions });
    } else {
      // Normal handling for other inputs
      setNewSpeciality({ ...newSpeciality, [name]: value });
    }
  };

  // Handler for editing speciality form inputs
  const handleEditSpecialityInputChange = (e) => {
    const { name, value } = e.target;

    // Special handling for multi-select
    if (name === "departementId") {
      // Convert selected options to an array of values
      const selectedOptions = Array.from(e.target.selectedOptions).map(option => option.value);
      setEditingSpeciality({ ...editingSpeciality, [name]: selectedOptions });
    } else {
      // Normal handling for other inputs
      setEditingSpeciality({ ...editingSpeciality, [name]: value });
    }
  };

  // Handler for editing service form inputs
  const handleEditServiceInputChange = (e) => {
    const { name, value } = e.target;
    setEditingService({ ...editingService, [name]: value });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewDepartment({ ...newDepartment, [name]: value });
  };

  const handleserviceInputChange = (e) => {
    const { name, value } = e.target;
    setNewService({ ...newService, [name]: value });
  };

  const addService = () => {
    setServices([...services, { name: '', price: '' }]);
  };

  // department 

  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [showDepartmentDetailsModal, setShowDepartmentDetailsModal] = useState(false);

  const handleShowDepartmentDetails = (dept) => {
    setSelectedDepartment(dept); // Définit le département sélectionné
    setShowDepartmentDetailsModal(true); // Ouvre le modal
  };

  const handleCloseDepartmentDetails = () => {
    setShowDepartmentDetailsModal(false); // Ferme le modal
  };

  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
  const [showDeleteConfirmModal2, setShowDeleteConfirmModal2] = useState(false);
  const [showDeleteConfirmModal3, setShowDeleteConfirmModal3] = useState(false);

  const handleShowDeleteConfirm = () => setShowDeleteConfirmModal(true);
  const handleShowDeleteConfirm2 = (special) => {
    setShowDeleteConfirmModal2(true)
    setSelectedSpeciality(special)
  };
  const handleShowDeleteConfirm3 = (serv) => {
    setShowDeleteConfirmModal3(true)
    setSelectedService(serv)
  };
  const handleCloseDeleteConfirm = () => setShowDeleteConfirmModal(false);
  const handleCloseDeleteConfirm2 = () => setShowDeleteConfirmModal2(false);
  const handleCloseDeleteConfirm3 = () => setShowDeleteConfirmModal3(false);

  const handleDelete = async () => {
    const token = localStorage.getItem('access_token');
    const response = await api.post('/api/deletedepartment', { department_id: selectedDepartment }, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });
    toast.success('Item deleted!');
    handleCloseDeleteConfirm();
  };

  const handleDelete2 = async () => {
    const token = localStorage.getItem('access_token');
    const response = await api.delete(`/api/specialities/${selectedSpeciality._id}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });
    toast.success('Item deleted!');
    handleCloseDeleteConfirm2();
  };

  const handleDelete3 = async () => {
    const token = localStorage.getItem('access_token');
    const response = await api.post(`/api/service/${selectedService._id}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });
    toast.success('Item deleted!');
    handleCloseDeleteConfirm3();
  };

  // Fonction pour gérer l'ajout d'un département
  const addDepartment = async () => {
    if (newDepartment.name && newDepartment.price_consult && newDepartment.description) {
      try {
        const token = localStorage.getItem('access_token');
        const hospitalId = selectedHospitalId;  // Utiliser l'ID de l'hôpital principal

        if (!hospitalId) {
          console.error('Hospital ID is missing.');
          return;  // Si l'ID est manquant, on arrête l'exécution
        }

        const departmentData = {
          ...newDepartment,
          hospital_id: hospitalId, // Ajouter l'ID de l'hôpital à la requête
        };

        const response = await api.post('/api/adddepartment', departmentData, {
          headers: {
            'Authorization': `Bearer ${token}`,
          },
        });

        // Mettre à jour l'état avec le département créé
        setDepartments([...departments, response.data.data]);

        // Réinitialiser le formulaire
        setNewDepartment({ name: '', description: '', price_consult: '' });
        handleCloseModal();  // Fermer le modal après l'ajout
      } catch (error) {
        toast.error(`${error.response.data.message}`)
        console.error('Error adding department:', error);
      }
    }
  };

  // liste des department
  useEffect(() => {
    const fetchDepartments = async () => {
      if (!mainHospital) return; // Si l'hôpital principal n'est pas défini, ne rien faire
      if (selectedHospitalId) {
        try {
          console.log("select", selectedHospitalId)
          const hospitalId = selectedHospitalId; // Utiliser l'ID de l'hôpital principal
          const response = await api.get(`/api/departments/hospital/${hospitalId}`, {
            headers: {
              'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
            }
          });

          // Mettre à jour les départements dans l'état
          setDepartments(response.data.data);
        } catch (error) {
          console.error('Erreur lors de la récupération des départements:', error);
          setMessage('Erreur lors de la récupération des départements.');
        }
      } else {
        try {
          console.log("select", mainHospital)
          const hospitalId = mainHospital._id; // Utiliser l'ID de l'hôpital principal
          const response = await api.get(`/api/departments/hospital/${hospitalId}`, {
            headers: {
              'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
            }
          });

          // Mettre à jour les départements dans l'état
          setDepartments(response.data.data);
        } catch (error) {
          console.error('Erreur lors de la récupération des départements:', error);
          setMessage('Erreur lors de la récupération des départements.');
        }
      };
    }

    fetchDepartments();
  }, [mainHospital, selectedHospitalId]);

  // userlist by department


  // speciality Managment

  const [selectedSpeciality, setSelectedSpeciality] = useState(null);
  const [showSpecialityDetailsModal, setShowSpecialityDetailsModal] = useState(false);

  const handleShowSpecialityDetails = (Speci) => {
    setSelectedSpeciality(Speci); // Définit le département sélectionné
    setShowSpecialityDetailsModal(true); // Ouvre le modal
  };

  // Fonction pour gérer l'ajout d'une spécialité
  const addSpeciality = async () => {
    if (newSpeciality.name && newSpeciality.description && newSpeciality.departementId) {
      try {
        const token = localStorage.getItem('access_token');
        const hospitalId = selectedHospitalId;  // Utiliser l'ID de l'hôpital principal

        if (!hospitalId) {
          console.error('Hospital ID is missing.');
          return;  // Si l'ID est manquant, on arrête l'exécution
        }

        const SpecialityData = {
          ...newSpeciality,
          hospital_id: hospitalId, // Ajouter l'ID de l'hôpital à la requête
        };

        // Effectuer la requête POST pour ajouter la spécialité
        const response = await api.post('/api/specialities', SpecialityData, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        // Mettre à jour l'état des spécialités après ajout
        // setSpecialities([...specialities, response.data]);

        // Réinitialiser les champs du formulaire
        setNewSpeciality({ name: '', description: '', departementId: '' });

        await fetchSpecialities();

        // Fermer le modal après l'ajout
        handleCloseSpecialityModal();


      } catch (error) {
        console.error('Erreur lors de l\'ajout de la spécialité:', error);
        toast.error(`${error.response.data.message}`)
      }
    } else {
      toast.success('Veuillez remplir tous les champs.!');
    }
  };

  // Function to update a speciality
  const updateSpeciality = async () => {
    if (!editingSpeciality || !editingSpeciality._id) {
      toast.error('No speciality selected for update');
      return;
    }

    try {
      const token = localStorage.getItem('access_token');

      const response = await api.put(`/api/specialities/${editingSpeciality._id}`, editingSpeciality, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      // Update the specialities list with the edited speciality
      const updatedSpecialities = specialities.map(spec =>
        spec._id === editingSpeciality._id ? response.data : spec
      );

      setSpecialities(updatedSpecialities);
      toast.success('Speciality updated successfully!');
      handleCloseEditSpecialityModal();

      // Refresh the specialities list
      await fetchSpecialities();

    } catch (error) {
      console.error('Error updating speciality:', error);
      toast.error('Failed to update speciality');
    }
  };

  // recuperer les specialites
  const fetchSpecialities = async () => {
    if (!mainHospital) return; // Si l'hôpital principal n'est pas défini, ne rien faire
    try {
      const hospitalId = selectedHospitalId; // Utiliser l'ID de l'hôpital principal
      if (selectedDepartment) {
        const response = await api.get(`/api/specialitiesbydepartment/${selectedDepartment._id}`, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
          }
        });
        setSpecialities(response.data);

      } else {
        const response = await api.get(`/api/specialities/hospital/${hospitalId}`, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
          }
        });
        setSpecialities(response.data.data);

      }
      // Mettre à jour l'état des spécialités dans le state

    } catch (error) {
      console.error('Erreur lors de la récupération des spécialités:', error);
      setMessage('Erreur lors de la récupération des spécialités.');
    }
  };

  useEffect(() => {
    fetchSpecialities();
  }, [mainHospital, selectedHospitalId, selectedDepartment]);



  // service Managment

  const [selectedService, setSelectedService] = useState(null);
  const [showServiceDetailsModal, setShowServiceDetailsModal] = useState(false);

  // service managment
  // Fonction pour gérer l'ajout d'une spécialité
  const addNewService = async () => {
    if (newService.name && newService.specialityId && newService.price_service && newService.description) {
      try {
        const token = localStorage.getItem('access_token');
        const hospitalId = selectedHospitalId;  // Utiliser l'ID de l'hôpital principal

        if (!hospitalId) {
          console.error('Hospital ID is missing.');
          return;  // Si l'ID est manquant, on arrête l'exécution
        }

        const ServiceData = {
          ...newService,
          hospital_id: hospitalId, // Ajouter l'ID de l'hôpital à la requête
        };

        // Effectuer la requête POST pour ajouter la spécialité
        const response = await api.post('/api/addservice', ServiceData, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        // Mettre à jour l'état des spécialités après ajout
        setServices([...services, response.data]);

        // Réinitialiser les champs du formulaire
        setNewService({ name: '', departementId: '', specialityId: '', price_service: '', description: '' });


        // Charger les spécialités à nouveau (pour s'assurer que la liste est bien à jour)
        await fetchServices();

        handleCloseServiceModal();

      } catch (error) {
        console.error('Erreur lors de l\'ajout de la service:', error);
        toast.error(`${error.response.data.message}`)
      }
    } else {
      toast.success('Veuillez remplir tous les champs.!');
    }
  };

  // Function to update a service
  const updateService = async () => {
    if (!editingService || !editingService._id) {
      toast.error('No service selected for update');
      return;
    }

    try {
      const token = localStorage.getItem('access_token');

      const response = await api.put(`/api/services/${editingService._id}`, editingService, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      // Update the services list with the edited service
      const updatedServices = services.map(service =>
        service._id === editingService._id ? response.data : service
      );

      setServices(updatedServices);
      toast.success('Service updated successfully!');
      handleCloseEditServiceModal();

      // Refresh the services list
      await fetchServices();

    } catch (error) {
      console.error('Error updating service:', error);
      toast.error('Failed to update service');
    }
  };

  // recuperer les specialites
  const fetchServices = async () => {
    if (!mainHospital) return; // Si l'hôpital principal n'est pas défini, ne rien faire
    if (selectedSpeciality) {
      try {
        const hospitalId = selectedSpeciality._id; // Utiliser l'ID de l'hôpital principal
        const response = await api.get(`/api/services/specialty/${hospitalId}`, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
          }
        });

        // Mettre à jour l'état des spécialités dans le state
        setServices(response.data.data);

      } catch (error) {
        console.error('Erreur lors de la récupération des spécialités:', error);
        setMessage('Erreur lors de la récupération des spécialités.');
      }
    } else {
      try {
        const hospitalId = selectedHospitalId; // Utiliser l'ID de l'hôpital principal
        const response = await api.get(`/api/services/hospital/${hospitalId}`, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
          }
        });

        // Mettre à jour l'état des spécialités dans le state
        setServices(response.data.data);

      } catch (error) {
        console.error('Erreur lors de la récupération des spécialités:', error);
        setMessage('Erreur lors de la récupération des spécialités.');
      }
    }
  };

  useEffect(() => {
    fetchServices();
  }, [mainHospital, selectedHospitalId, selectedSpeciality]);

  const handlespecialitybydepartment = (event) => {
    const selectedDepartmentId = event.target.value;

    // Mise à jour du service avec le département sélectionné et réinitialisation des spécialités
    setNewService((prevState) => ({
      ...prevState,
      departementId: selectedDepartmentId,
      specialities: [],
    }));

    // Filtrer les spécialités qui contiennent le département sélectionné dans leur tableau departementId
    const updatedSpecialities = specialities.filter(
      (speciality) => speciality.departementId && speciality.departementId.includes(selectedDepartmentId)
    );

    setFilteredSpecialities(updatedSpecialities);
  };

  // Function to handle department change when editing a service
  const handleEditServiceDepartmentChange = (event) => {
    const selectedDepartmentId = event.target.value;

    // Update the editing service with the selected department
    setEditingService({
      ...editingService,
      departementId: selectedDepartmentId,
      specialityId: '' // Reset speciality when changing department
    });

    // Filter specialities for the selected department
    const updatedSpecialities = specialities.filter(
      (speciality) => speciality.departementId && speciality.departementId.includes(selectedDepartmentId)
    );

    setFilteredSpecialities(updatedSpecialities);
  };

  // État pour afficher le toast modal
  const [showToast, setShowToast] = useState(false);

  // Fonction pour ouvrir et fermer le modal
  const handleSave = () => {
    setShowToast(true); // Afficher le modal
    setTimeout(() => setShowToast(false), 3000); // Fermer automatiquement après 3 secondes
  };

  // news hospital adding
  const [showaddressModal, setShowAddressModal] = useState(false); // Contrôle du modal
  const [clinicName, setClinicName] = useState(''); // Valeur affichée dans l'input
  const [clinicAddress, setClinicAddress] = useState(''); // Valeur affichée dans l'input
  const [country, setCountry] = useState(null);
  const [currentState, setCurrentState] = useState(null);
  const [currentCity, setCurrentCity] = useState(null);
  const [currency, setCurrency] = useState(null);
  const [telephone1, setTelephone1] = useState(''); // Téléphone 1
  const [telephone2, setTelephone2] = useState(''); // Téléphone 2

  // Ouvrir et fermer le modal
  const handleInputClick = () => setShowAddressModal(true);
  const handleCloseInputModal = () => setShowAddressModal(false);

  // Sauvegarde des sélections et mise à jour de l'adresse
  const handleSaveAddress = () => {
    const address = `${country?.name}, ${currentCity?.name}, ${currentState?.name}`;
    setClinicAddress(address); // Mise à jour de l'input
    handleCloseInputModal(); // Ferme le modal
  };


  // Soumission du formulaire
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Données du formulaire
    const selectedCountry = country?.name;
    const selectedCity = currentCity?.name;
    const selectedDepartment = currentState?.name;

    const formData = {
      hospital_name: clinicName,
      hospital_country: selectedCountry,
      hospital_city: selectedCity,
      hospital_state_province: selectedDepartment,
      hospital_phone: telephone1,
      hospital_phone2: telephone2,
      hospital_currency: currency

    };

    try {
      // Récupérez le token depuis le localStorage
      const token = localStorage.getItem('access_token');
      if (!token) {
        throw new Error('Session expired. Please log in again.');
      }

      // Effectuez la requête à l'API
      const response = await api.post('/api/addhospital', formData, {
        headers: {
          'Authorization': `Bearer ${token}`, // Ajoutez le token dans l'en-tête
          'Content-Type': 'application/json',
        },
      });

      // Si la requête réussit
      toast.success('Hospital added successfully!');

    } catch (error) {
      // Gestion des erreurs
      if (error.response?.status === 401) {
        toast.error('Session expired. Redirecting to login...');
        localStorage.removeItem('access_token'); // Supprimez le token
        window.location.href = '/login'; // Redirigez l'utilisateur
      } else {
        const errorMessage = error.response?.data?.error || error.message || 'An unknown error occurred.';
        toast.error(`Error: ${errorMessage}`);
      }
    }
  };



  // Fonction pour récupérer la liste des hôpitaux pour l'administrateur
  useEffect(() => {
    const fetchHospitals = async () => {
      if (!userId) {
        setMessage('Utilisateur non authentifié.');
        return;
      }
      try {
        const token = localStorage.getItem('access_token');
        const response = await api.get(`/api/hospitals/admin/` + token, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`
          }
        });

        // Filtrer l'hôpital principal (is_main_hospital: true) et les autres hôpitaux
        const mainHospitalData = response.data.find(hospital => hospital.is_main_hospital == true);
        const otherHospitalsData = response.data.filter(hospital => hospital.is_main_hospital !== true);

        if (mainHospitalData) {
          setMainHospital(mainHospitalData); // Stocker l'hôpital principal
          setDepartments(mainHospitalData.departments); // Associer les départements
          setSpecialities(mainHospitalData.specialities); // Associer les spécialités
        }
        setHospitals(response.data); // Sauvegarder tous les hôpitaux
        setOtherHospitals(otherHospitalsData); // Stocker les autres hôpitaux
      } catch (error) {
        console.error('Erreur lors de la récupération des hôpitaux:', error);
        setMessage('Erreur lors de la récupération des hôpitaux.');
      }
    };

    if (userId) {
      fetchHospitals(); // Appeler la fonction pour récupérer les hôpitaux uniquement si l'utilisateur est authentifié
    }
  }, [userId]);

  const options = Array.isArray(departments)
    ? departments.map((department) => ({
      value: department._id,
      label: department.name,
    }))
    : [];
  const handleSpecialitySelectChange = (selectedOptions) => {
    const values = Array.isArray(selectedOptions)
      ? selectedOptions.map(option => option.value)
      : [];

    setNewSpeciality(prev => ({
      ...prev,
      departementId: values,
    }));
  };

  const handleEditDepartementSelectChange = (selectedOptions) => {
    const values = Array.isArray(selectedOptions)
      ? selectedOptions.map(option => option.value)
      : [];

    setEditingSpeciality(prev => ({
      ...prev,
      departementId: values,
    }));
  };



  return (

    <div className="hosp-layout">
      <div className="hosp-dashboard__header">
        <ToastContainer />

        <div className="hosp-profile-header" style={{ backgroundColor: 'var(--hosp-background-color)', border: "none" }}>
          <div className="hosp-header__content">
            {/* Titre à gauche */}
            <div className="hosp-header__title">
              <h4 className="hosp-page__title"><b>Hospital Settings</b></h4>
            </div>

            {/* Profil utilisateur à droite */}
            <div className="hosp-user__profile">
              {/* Indicateur de statut en ligne (optionnel) */}
              <div className="hosp-status__indicator"></div>

              <img
                src={UserData?.picture || Adminprofil}
                className='hosp-profile__image'
                alt="Profile Icon"
              />

              <div className="hosp-user__details">
                <span className="hosp-user__name">{UserData.firstname} {UserData.lastname}</span>
                <p className="hosp-user__role">
                  {UserData.role?.name}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="hosp-container">
          <div className="hosp-dropdown mt-3 mb-4">
            <button
              className="hosp-dropdown__toggle d-flex align-items-center text-start"
              type="button"
              onClick={toggleMainDropdown}
            >
              <span className="hosp-dropdown__indicator"></span>
              Hospitals
            </button>

            {dropdownState.main && (
              <div className="hosp-dropdown__content">
                {/* Hospital selection */}
                <div className="hosp-form__group mt-3 mb-4">
                  <label className="hosp-form__label">Hospital Name</label>
                  <select
                    className="hosp-form__control"
                    name="hospitalId"
                    value={selectedHospitalId || ''}
                    onChange={(e) => handleHospitalChange(e.target.value)}
                  >
                    <option value="">Select a hospital</option>
                    {hospitals && Array.isArray(hospitals) && hospitals.length > 0 ? (
                      hospitals.map((hospital) => (
                        <option key={hospital._id} value={hospital._id}>
                          {hospital.hospital_name}
                        </option>
                      ))
                    ) : (
                      <option disabled>No hospitals available.</option>
                    )}
                  </select>
                </div>

                {/* Departments Dropdown */}
                <div className="hosp-dropdown mt-5">
                  <button
                    className="hosp-btn hosp-btn--primary hosp-dropdown__toggle w-100 text-start"
                    type="button"
                    onClick={toggleDepartments}
                  >
                    Departments
                  </button>

                  {dropdownState.departments && (
                    <div className="hosp-dropdown__content">
                      {departments && Array.isArray(departments) && departments.length > 0 ? (
                        <div className="d-flex flex-wrap">
                          <span className="hosp-badge hosp-badge--orange m-1">
                            <a
                              className="hosp-badge__link hosp-cursor--pointer"
                              onClick={() => setSelectedDepartment(null)}
                            >
                              All<FaArrowDown />
                            </a>
                          </span>

                          {departments.map((dept, index) => (
                            <span key={index} className="hosp-badge hosp-badge--orange m-1">
                              <a
                                href="#"
                                className="hosp-badge__link hosp-cursor--pointer"
                                onClick={() => handleShowDepartmentDetails(dept)}
                              >
                                {dept.name} <FaArrowUp />
                              </a>
                              <span
                                className="ms-1 hosp-cursor--pointer"
                                onClick={() => setSelectedDepartment(dept)}
                              >
                                <FaArrowDown />
                              </span>
                            </span>
                          ))}
                        </div>
                      ) : (
                        <p>No departments available.</p>
                      )}

                      <div className="d-flex justify-content-end mt-3">
                        <button
                          onClick={handleShowModal}
                          className="hosp-btn hosp-btn--add"
                        >
                          <FaListAlt /> Add Department
                        </button>
                      </div>
                    </div>
                  )}
                </div>

                {/* Specialities Dropdown */}
                <div className="hosp-dropdown mt-4">
                  <button
                    className="hosp-btn hosp-btn--primary hosp-dropdown__toggle w-100 text-start"
                    type="button"
                    onClick={toggleSpecialities}
                  >
                    Speciality ({selectedDepartment?.name || "ALL"})
                  </button>

                  {dropdownState.specialities && (
                    <div className="hosp-dropdown__content">
                      <div className="d-flex flex-wrap">
                        <span className="hosp-badge hosp-badge--orange m-1">
                          <a
                            className="hosp-badge__link hosp-cursor--pointer"
                            onClick={() => setSelectedSpeciality(null)}
                          >
                            All<FaArrowDown />
                          </a>
                        </span>

                        {specialities && Array.isArray(specialities) && specialities.length > 0 ? (
                          specialities.map((spec, index) => (
                            <span key={index} className="hosp-badge hosp-badge--green m-1">
                              <a
                                onClick={() => setSelectedSpeciality(spec)}
                                className="hosp-badge__link hosp-cursor--pointer"
                              >
                                {spec.name} <FaArrowUp />
                              </a>
                              <span
                                className="ms-1 hosp-cursor--pointer"
                                onClick={() => handleShowEditSpecialityModal(spec)}
                              >
                                <FaEdit className="text-primary" />
                              </span>
                              <span
                                className="ms-1 hosp-cursor--pointer"
                                onClick={() => handleShowDeleteConfirm2(spec)}
                              >
                                <FaRegTrashAlt className="hosp-btn--delete" />
                              </span>
                            </span>
                          ))
                        ) : (
                          <p>No specialities available.</p>
                        )}
                      </div>

                      <div className="d-flex justify-content-end mt-3">
                        <button
                          onClick={handleShowSpecialityModal}
                          className="hosp-btn hosp-btn--add"
                        >
                          <FaListAlt /> Add Speciality
                        </button>
                      </div>
                    </div>
                  )}
                </div>

                {/* Services Dropdown */}
                <div className="hosp-dropdown mt-4">
                  <button
                    className="hosp-btn hosp-btn--primary hosp-dropdown__toggle w-100 text-start"
                    type="button"
                    onClick={toggleServices}
                  >
                    Services ({selectedSpeciality?.name || "ALL"})
                  </button>

                  {dropdownState.services && (
                    <div className="hosp-dropdown__content">
                      {services && Array.isArray(services) && services.length > 0 ? (
                        <div className="d-flex flex-wrap">
                          {services.map((serv, index) => (
                            <span key={index} className="hosp-badge hosp-badge--green m-1">
                              <a className="hosp-badge__link">
                                {serv.name} <FaArrowUp />
                              </a>
                              <span
                                className="ms-1 hosp-cursor--pointer"
                                onClick={() => handleShowEditServiceModal(serv)}
                              >
                                <FaEdit className="text-primary" />
                              </span>
                              <span
                                className="ms-1 hosp-cursor--pointer"
                                onClick={() => handleShowDeleteConfirm3(serv)}
                              >
                                <FaRegTrashAlt className="hosp-btn--delete" />
                              </span>
                            </span>
                          ))}
                        </div>
                      ) : (
                        <p>No services available.</p>
                      )}

                      <div className="d-flex justify-content-end mt-3">
                        <button
                          onClick={handleShowServiceModal}
                          className="hosp-btn hosp-btn--add"
                        >
                          <FaListAlt /> Add Service
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>

          {/* Modal for Adding a Department */}
          <Modal
            show={showModal}
            onHide={handleCloseModal}
            centered
            size="lg"
            className="hosp-modal"
          >
            <Modal.Header className="hosp-modal__header">
              <Modal.Title className="hosp-modal__title">Add New Department</Modal.Title>
            </Modal.Header>

            <Modal.Body className="hosp-modal__body">
              {successMessage && (
                <div className="alert alert-success" role="alert">
                  {successMessage}
                </div>
              )}

              <div className="hosp-form__group">
                <label className="hosp-form__label">Name</label>
                <input
                  type="text"
                  className="hosp-form__control"
                  name="name"
                  placeholder="Dermatology"
                  value={newDepartment.name}
                  onChange={handleInputChange}
                />
              </div>

              <div className="hosp-form__group">
                <label className="hosp-form__label">Consultation Price:</label>
                <div className="hosp-input__group">
                  <input
                    type="number"
                    className="hosp-form__control"
                    placeholder="20000"
                    name="price_consult"
                    value={newDepartment.price_consult}
                    onChange={handleInputChange}
                  />
                  <span className="hosp-input__addon">XOF</span>
                </div>
              </div>

              <div className="hosp-form__group">
                <textarea
                  className="hosp-form__textarea"
                  name="description"
                  placeholder="Description"
                  rows="3"
                  value={newDepartment.description}
                  onChange={handleInputChange}
                ></textarea>
              </div>
            </Modal.Body>

            <Modal.Footer className="hosp-modal__footer">
              <div className="mx-auto">
                <Button variant="" onClick={addDepartment} className="hosp-btn hosp-btn--action">
                  Continue <FaArrowRight />
                </Button>
              </div>
            </Modal.Footer>
          </Modal>

          {/* Department Details Modal */}
          <Modal
            show={showDepartmentDetailsModal}
            onHide={handleCloseDepartmentDetails}
            centered
            size="lg"
            className="hosp-modal"
          >
            <Modal.Header className="hosp-modal__header">
              <Modal.Title className="hosp-modal__title">
                {selectedDepartment ? selectedDepartment.name : 'Department Details'}
              </Modal.Title>
            </Modal.Header>

            <Modal.Body className="hosp-modal__body">
              <div className="department-details">
                <div className="row mb-4">
                  <div className="col-md-2">
                    <img src={group} alt="department icon" className="hosp-department__icon" />
                  </div>

                  <div className="col-md-5 mt-4">
                    <label className="hosp-form__label">Name</label>
                    <input
                      type="text"
                      className="hosp-form__control"
                      defaultValue={selectedDepartment ? selectedDepartment.name : ''}
                      readOnly
                    />
                  </div>

                  <div className="col-md-5 mt-4">
                    <label className="hosp-form__label">Code</label>
                    <input
                      type="text"
                      className="hosp-form__control"
                      defaultValue={selectedDepartment ? selectedDepartment.codeDep : ''}
                      readOnly
                    />
                  </div>
                </div>

                <div className="hosp-form__group">
                  <label className="hosp-form__label">Description</label>
                  <textarea
                    className="hosp-form__textarea"
                    rows="4"
                    defaultValue={selectedDepartment ? selectedDepartment.description : ''}
                    readOnly
                  ></textarea>
                </div>

                <div className="row mb-4">
                  <div className="col-md-12">
                    <label className="hosp-form__label">Prix Consultation</label>
                    <div className="hosp-input__group">
                      <input
                        type="text"
                        className="hosp-form__control"
                        defaultValue={selectedDepartment ? selectedDepartment.price_consult : ''}
                        readOnly
                      />
                      <span className="hosp-input__addon">XOF</span>
                    </div>
                  </div>
                </div>

                {/* <div className="mb-4">
                <button className="hosp-btn hosp-btn--primary w-100">
                  Docteurs sous ce département <FaArrowDown />
                </button>
              </div> */}
              </div>
            </Modal.Body>

            <Modal.Footer className="hosp-modal__footer d-flex justify-content-between">
              <button
                className="hosp-btn hosp-btn--danger"
                onClick={handleShowDeleteConfirm}
              >
                Delete <FaRegTrashAlt />
              </button>

              <button
                className="hosp-btn hosp-btn--primary"
                onClick={() => handleShowEditDepartmentModal(selectedDepartment)}
              >
                Edit <FaEdit />
              </button>

              {/* <button className="hosp-btn hosp-btn--success">
              Save <FaArrowRight />
            </button> */}
            </Modal.Footer>
          </Modal>

          {/* Modal for Editing a Department */}
          <Modal
            show={showEditDepartmentModal}
            onHide={handleCloseEditDepartmentModal}
            centered
            size="lg"
            className="hosp-modal"
          >
            <Modal.Header className="hosp-modal__header">
              <Modal.Title className="hosp-modal__title">Edit Department</Modal.Title>
            </Modal.Header>

            <Modal.Body className="hosp-modal__body">
              {successMessage && (
                <div className="alert alert-success" role="alert">
                  {successMessage}
                </div>
              )}

              <div className="hosp-form__group">
                <label className="hosp-form__label">Name</label>
                <input
                  type="text"
                  className="hosp-form__control"
                  name="name"
                  value={editingDepartment?.name || ''}
                  onChange={handleEditDepartmentInputChange}
                />
              </div>

              <div className="hosp-form__group">
                <label className="hosp-form__label">Consultation Price:</label>
                <div className="hosp-input__group">
                  <input
                    type="number"
                    className="hosp-form__control"
                    name="price_consult"
                    value={editingDepartment?.price_consult || ''}
                    onChange={handleEditDepartmentInputChange}
                  />
                  <span className="hosp-input__addon">XOF</span>
                </div>
              </div>

              <div className="hosp-form__group">
                <textarea
                  className="hosp-form__textarea"
                  name="description"
                  placeholder="Description"
                  rows="3"
                  value={editingDepartment?.description || ''}
                  onChange={handleEditDepartmentInputChange}
                ></textarea>
              </div>
            </Modal.Body>

            <Modal.Footer className="hosp-modal__footer">
              <div className="mx-auto">
                <Button variant="" onClick={updateDepartment} className="hosp-btn hosp-btn--action">
                  Save Changes <FaArrowRight />
                </Button>
              </div>
            </Modal.Footer>
          </Modal>

          {/* Modal for Editing a Speciality */}
          <Modal
            show={showEditSpecialityModal}
            onHide={handleCloseEditSpecialityModal}
            centered
            className="hosp-modal"
          >
            <Modal.Header className="hosp-modal__header">
              <Modal.Title className="hosp-modal__title">Edit Speciality</Modal.Title>
            </Modal.Header>

            <Modal.Body className="hosp-modal__body">
              <div className="hosp-form__group">
                <label className="hosp-form__label">Name</label>
                <input
                  type="text"
                  className="hosp-form__control"
                  name="name"
                  value={editingSpeciality?.name || ''}
                  onChange={handleEditSpecialityInputChange}
                />
              </div>

              <div className="hosp-form__group">
                <label className="hosp-form__label">Department</label>
                <div className="hosp-select__container">
                  <Select
                    isMulti
                    name="departementId"
                    className="basic-multi-select"
                    classNamePrefix="select"
                    value={
                      Array.isArray(editingSpeciality?.departementId)
                        ? options.filter(opt =>
                          editingSpeciality.departementId.includes(opt.value)
                        )
                        : []
                    }
                    onChange={handleEditDepartementSelectChange}
                    options={options}
                  />
                </div>
              </div>

              <div className="hosp-form__group">
                <textarea
                  className="hosp-form__textarea"
                  name="description"
                  placeholder="Description"
                  rows="3"
                  value={editingSpeciality?.description || ''}
                  onChange={handleEditSpecialityInputChange}
                ></textarea>
              </div>
            </Modal.Body>

            <Modal.Footer className="hosp-modal__footer">
              <div className="mx-auto">
                <Button variant="" onClick={updateSpeciality} className="hosp-btn hosp-btn--action">
                  Save Changes <FaArrowRight />
                </Button>
              </div>
            </Modal.Footer>
          </Modal>

          {/* Modal for Adding a Speciality */}
          <Modal
            show={showSpecialityModal}
            onHide={handleCloseSpecialityModal}
            centered
            className="hosp-modal"
          >
            <Modal.Header className="hosp-modal__header">
              <Modal.Title className="hosp-modal__title">Add New Speciality</Modal.Title>
            </Modal.Header>

            <Modal.Body className="hosp-modal__body">
              <div className="hosp-form__group">
                <label className="hosp-form__label">Name</label>
                <input
                  type="text"
                  className="hosp-form__control"
                  name="name"
                  placeholder="Emergencist"
                  value={newSpeciality.name}
                  onChange={handleSpecialityInputChange}
                />
              </div>

              <div className="hosp-form__group">
                <label className="hosp-form__label">Department</label>
                <div className="hosp-select__container">
                  <Select
                    isMulti
                    name="departementId"
                    className="basic-multi-select"
                    classNamePrefix="select"
                    value={
                      Array.isArray(newSpeciality.departementId)
                        ? options.filter(opt =>
                          newSpeciality.departementId.includes(opt.value)
                        )
                        : []
                    }
                    onChange={handleSpecialitySelectChange}
                    options={options}
                  />
                </div>
              </div>

              <div className="hosp-form__group">
                <textarea
                  className="hosp-form__textarea"
                  name="description"
                  placeholder="Description"
                  rows="3"
                  value={newSpeciality.description}
                  onChange={handleSpecialityInputChange}
                ></textarea>
              </div>
            </Modal.Body>

            <Modal.Footer className="hosp-modal__footer">
              <div className="mx-auto">
                <Button variant="" onClick={addSpeciality} className="hosp-btn hosp-btn--action">
                  Continue <FaArrowRight />
                </Button>
              </div>
            </Modal.Footer>
          </Modal>

          {/* Modal for Adding a Service */}
          <Modal
            show={showServiceModal}
            onHide={handleCloseServiceModal}
            centered
            className="hosp-modal"
          >
            <Modal.Header className="hosp-modal__header">
              <Modal.Title className="hosp-modal__title">Add New Service</Modal.Title>
            </Modal.Header>

            <form>
              <Modal.Body className="hosp-modal__body">
                <div className="hosp-form__group">
                  <label className="hosp-form__label">Name</label>
                  <input
                    type="text"
                    className="hosp-form__control"
                    name="name"
                    placeholder="Emergencist"
                    value={newService.name}
                    onChange={handleserviceInputChange}
                  />
                </div>

                <div className="hosp-form__group">
                  <label className="hosp-form__label">Department</label>
                  <select
                    className="hosp-form__control"
                    name="departementId"
                    value={newService.departementId}
                    onChange={handlespecialitybydepartment}
                  >
                    <option value="">Select a Department</option>
                    {departments && Array.isArray(departments) && departments.length > 0 ? (
                      departments.map((department) => (
                        <option key={department._id} value={department._id}>
                          {department.name}
                        </option>
                      ))
                    ) : (
                      <option disabled>No departments available.</option>
                    )}
                  </select>
                </div>

                <div className="hosp-form__group">
                  <label className="hosp-form__label">Speciality</label>
                  <select
                    className="hosp-form__control"
                    name="specialityId"
                    value={newService.specialityId}
                    onChange={handleserviceInputChange}
                  >
                    <option value="">Select a speciality</option>
                    {filteredSpecialities && Array.isArray(filteredSpecialities) && filteredSpecialities.length > 0 ? (
                      filteredSpecialities.map((filteredSpecialitie) => (
                        <option key={filteredSpecialitie._id} value={filteredSpecialitie._id}>
                          {filteredSpecialitie.name}
                        </option>
                      ))
                    ) : (
                      <option disabled>No speciality available.</option>
                    )}
                  </select>
                </div>

                <div className="hosp-form__group">
                  <label className="hosp-form__label">Price</label>
                  <div className="hosp-input__group">
                    <input
                      type="number"
                      className="hosp-form__control"
                      name="price_service"
                      placeholder="Price"
                      value={newService.price_service}
                      onChange={handleserviceInputChange}
                    />
                    <span className="hosp-input__addon">XOF</span>
                  </div>
                </div>

                <div className="hosp-form__group">
                  <textarea
                    className="hosp-form__textarea"
                    name="description"
                    placeholder="Description"
                    rows="3"
                    value={newService.description}
                    onChange={handleserviceInputChange}
                  ></textarea>
                </div>
              </Modal.Body>

              <Modal.Footer className="hosp-modal__footer">
                <div className="mx-auto">
                  <Button onClick={addNewService} className="hosp-btn hosp-btn--action">
                    Continue <FaArrowRight />
                  </Button>
                </div>
              </Modal.Footer>
            </form>
          </Modal>

          {/* Modal for Editing a Service */}
          <Modal
            show={showEditServiceModal}
            onHide={handleCloseEditServiceModal}
            centered
            className="hosp-modal"
          >
            <Modal.Header className="hosp-modal__header">
              <Modal.Title className="hosp-modal__title">Edit Service</Modal.Title>
            </Modal.Header>

            <Modal.Body className="hosp-modal__body">
              <div className="hosp-form__group">
                <label className="hosp-form__label">Name</label>
                <input
                  type="text"
                  className="hosp-form__control"
                  name="name"
                  value={editingService?.name || ''}
                  onChange={handleEditServiceInputChange}
                />
              </div>

              <div className="hosp-form__group">
                <label className="hosp-form__label">Department</label>
                <select
                  className="hosp-form__control"
                  name="departementId"
                  value={editingService?.departementId || ''}
                  onChange={handleEditServiceDepartmentChange}
                >
                  <option value="">Select a Department</option>
                  {departments && Array.isArray(departments) && departments.length > 0 ? (
                    departments.map((department) => (
                      <option key={department._id} value={department._id}>
                        {department.name}
                      </option>
                    ))
                  ) : (
                    <option disabled>No departments available.</option>
                  )}
                </select>
              </div>

              <div className="hosp-form__group">
                <label className="hosp-form__label">Speciality</label>
                <select
                  className="hosp-form__control"
                  name="specialityId"
                  value={editingService?.specialityId || ''}
                  onChange={handleEditServiceInputChange}
                >
                  <option value="">Select a Speciality</option>
                  {filteredSpecialities && Array.isArray(filteredSpecialities) && filteredSpecialities.length > 0 ? (
                    filteredSpecialities.map((speciality) => (
                      <option key={speciality._id} value={speciality._id}>
                        {speciality.name}
                      </option>
                    ))
                  ) : (
                    <option disabled>No specialities available.</option>
                  )}
                </select>
              </div>

              <div className="hosp-form__group">
                <label className="hosp-form__label">Price</label>
                <div className="hosp-input__group">
                  <input
                    type="number"
                    className="hosp-form__control"
                    name="price_service"
                    value={editingService?.price_service || ''}
                    onChange={handleEditServiceInputChange}
                  />
                  <span className="hosp-input__addon">XOF</span>
                </div>
              </div>

              <div className="hosp-form__group">
                <textarea
                  className="hosp-form__textarea"
                  name="description"
                  placeholder="Description"
                  rows="3"
                  value={editingService?.description || ''}
                  onChange={handleEditServiceInputChange}
                ></textarea>
              </div>
            </Modal.Body>

            <Modal.Footer className="hosp-modal__footer">
              <div className="mx-auto">
                <Button onClick={updateService} className="hosp-btn hosp-btn--action">
                  Save Changes <FaArrowRight />
                </Button>
              </div>
            </Modal.Footer>
          </Modal>

          {/* Delete Confirmation Modals */}
          <Modal
            show={showDeleteConfirmModal}
            onHide={handleCloseDeleteConfirm}
            centered
            size="sm"
            className="hosp-modal"
          >
            <Modal.Body className="hosp-modal__body">
              <p className="text-center">Are you sure you want to delete this department?</p>
            </Modal.Body>

            <Modal.Footer className="hosp-modal__footer d-flex justify-content-between">
              <button className="hosp-btn hosp-btn--primary" onClick={handleCloseDeleteConfirm}>
                Back
              </button>
              <button className="hosp-btn hosp-btn--danger" onClick={handleDelete}>
                Delete
              </button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={showDeleteConfirmModal2}
            onHide={handleCloseDeleteConfirm2}
            centered
            size="sm"
            className="hosp-modal"
          >
            <Modal.Body className="hosp-modal__body">
              <p className="text-center">Are you sure you want to delete this speciality?</p>
            </Modal.Body>

            <Modal.Footer className="hosp-modal__footer d-flex justify-content-between">
              <button className="hosp-btn hosp-btn--primary" onClick={handleCloseDeleteConfirm2}>
                Back
              </button>
              <button className="hosp-btn hosp-btn--danger" onClick={handleDelete2}>
                Delete
              </button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={showDeleteConfirmModal3}
            onHide={handleCloseDeleteConfirm3}
            centered
            size="sm"
            className="hosp-modal"
          >
            <Modal.Body className="hosp-modal__body">
              <p className="text-center">Are you sure you want to delete this service?</p>
            </Modal.Body>

            <Modal.Footer className="hosp-modal__footer d-flex justify-content-between">
              <button className="hosp-btn hosp-btn--primary" onClick={handleCloseDeleteConfirm3}>
                Back
              </button>
              <button className="hosp-btn hosp-btn--danger" onClick={handleDelete3}>
                Delete
              </button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default Hospital;
